import { render, staticRenderFns } from "./no-address.vue?vue&type=template&id=5a4c65ed&scoped=true"
import script from "./no-address.vue?vue&type=script&lang=js"
export * from "./no-address.vue?vue&type=script&lang=js"
import style0 from "./no-address.vue?vue&type=style&index=0&id=5a4c65ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4c65ed",
  null
  
)

export default component.exports